import uuid from 'react-uuid'
import { PropsCreatePost } from 'src/components/InputMarkdown/types'
import { PostType } from 'src/hook/usePosts'

export const defaultPublication: PropsCreatePost = {
  uuid: uuid(),
  title: '',
  postType: PostType.TEXT,
  collectionId: 0
}

const genereateUUID = (): string => uuid()

export const getDefaultPublication = (): PropsCreatePost => ({
  uuid: genereateUUID(),
  title: '',
  postType: PostType.TEXT,
  collectionId: 0
})
